import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { DisplayCurrencyService } from '@core/services/display-currency/display-currency.service';

@Component({
  selector: 'app-kiosk-currency-disclaimer',
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (displayCurrency.selectedRate(); as rate) {
      <p
        class="text-base text-neutral-500"
        [class.px-4]="inset()"
        [class.pb-2]="inset()"
      >
        {{
          'kiosk.currency.disclaimer' | translate: { currency: rate.code, base: baseCurrencyCode() }
        }}
      </p>
    }
  `,
  styles: [':host { display: contents; }'],
})
export class KioskCurrencyDisclaimerComponent {
  readonly inset = input(false);

  protected readonly displayCurrency = inject(DisplayCurrencyService);
  private readonly marketplaceSelector = inject(MarketplaceStoreSelector);

  protected baseCurrencyCode(): string {
    return (this.marketplaceSelector.selectMarketplace().currency ?? '').toUpperCase();
  }
}
